import * as Sentry from '@sentry/browser';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { ContextProvider } from './component/context';
import './i18n';
import './index.css';
import reportWebVitals from './reportWebVitals';
import version from './version';

const root = document.getElementById('root');

if (!root) {
    throw new Error('Missing root element');
}

const { environmentName, sentryDsn, baseUrl } = root.dataset;

Sentry.init({
    dsn: sentryDsn,
    environment: environmentName,
    release: version ? `paollo-front@${version}` : undefined,
});

ReactDOM.render(
    <React.StrictMode>
        <ContextProvider baseUrl={baseUrl as string}>
            <App />
        </ContextProvider>
    </React.StrictMode>,
    root,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
